export default __webpack_public_path__ + "static/media/leader.baed0059.png";